import {
    FETCH_CONTENT_FIELDS,
    FETCH_CONTENT_FIELDS_LIST,
} from "../actions/types";

export const reducer = (state = {}, action) => {
    switch (action.type) {
        case FETCH_CONTENT_FIELDS:
            return { ...state, singleContentField: action.payload };
        case FETCH_CONTENT_FIELDS_LIST:
            return { ...state, contentFieldsList: action.payload };
        default:
            return state;
    }
};
